import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { RootState } from "../store";

export default function AuthRoute() {
  const user = useSelector((state: RootState) => state.user);

  if (user?.user?.role) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Outlet />;
}
